export { toPromise } from './to-promise';
